import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { palette } from '@dev/ee-components';
import { Dialog as MaterialDialog, Portal } from '@material-ui/core';
import { push as Push } from 'redux-first-history';
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { TemplateEditor } from '@/components/TemplateEditor';

import {
    CloseGallery,
    CloseTemplateEditor,
    SelectTemplate,
    getCampainCreatorStore,
} from '@/store/campaignCreator/actions';
import { HideMediaManager } from '@/store/mediaManager/actions';
import { useHistoryBackActionContext } from '@/services/hooks/useHistoryBackAction';

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;

    .MuiContainer-root {
        padding-top: 60px;
    }
`;

export const TemplateEditorModal = (): JSX.Element => {
    const dispatch = useDispatch();
    const historyBackAction = useHistoryBackActionContext();
    
    const {
        templateEditor: { sourceTemplateName }
    } = useSelector(getCampainCreatorStore);

    const {
        templateEditor: { isOpen },
    } = useSelector(getCampainCreatorStore);


    useEffect(() => {
        if (!isOpen){
            return;
        }
        
        dispatch(SetToastPortalWrapper(true));
        historyBackAction?.pushBackCallback(closeModals)

        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, [isOpen]);

    const closeModals = (): boolean => {
        dispatch(CloseGallery());
        dispatch(HideMediaManager());
        dispatch(CloseTemplateEditor());
        
        return true;
    };

    const closeEditorCallback = (templateName?: string): void => {
        if (templateName) {
            dispatch(SelectTemplate(templateName, false, false));
        }
        historyBackAction.popAndExecuteBackCallback();
    };


    return (
        <Portal>
            <MaterialDialog open={isOpen} fullScreen scroll="body">
                <Overlay>
                    <TemplateEditor
                        popupsMinimalZIndex={1400}
                        editedTemplateName={sourceTemplateName}
                        onSaveAndExitCallback={closeEditorCallback}
                        onBreadcrumbClick={closeEditorCallback}
                        useIndividualPaths={false}
                        useDraftScope
                    />
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
